import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import PruebaConocimientoCardImg from "../../components/UmmIApps/Cards/PruebaConocimientoCardImg.png";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AgregarTipoPreguntas from "../../components/Form/Fields/AgregarTipoPreguntas";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionMiniTest from "../../components/Form/Fields/DuracionMiniTest";
import TemaEvaluacion from "../../components/Form/Fields/TemaEvaluacion";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const PruebaConocimientoPage = () => {
  const {
    materiaId,
    nivelId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();

  const [isPreguntaAdded, setIsPreguntaAdded] = useState(false)

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("test", { promptData });
 
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      preguntas: {
        tipoPreguntas: "",
        cantidadPreguntas: 1,
      },
      cantidad_tiempo: 5,
      caracterizacion: "",
      condiciones_contexto: "",
      tema_evaluacion: "",
    };
    handleInitialPromptData(init, "test");
    setTextoInicial(
      "A continuación te propongo algunas preguntas para tu evaluación. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  
  useEffect(() => {
    console.log(isPreguntaAdded);
    
  }, [isPreguntaAdded]);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={PruebaConocimientoCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Prueba de conocimiento"
        description="Crea pruebas de conocimiento que permitan medir el progreso de los estudiantes en relación con los objetivos de aprendizaje establecidos."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
           
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
          </Grid>
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"} sx={{ mt: 3 }}>
          <TemaEvaluacion />
        </Grid>
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Grid item lg={12}>
            <AgregarTipoPreguntas setIsPreguntaAdded={setIsPreguntaAdded}/>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          display={"flex"}
          flexDirection={"row"}
          sx={{ mt: 4 }}
        >
          <Grid item lg={12}>
            <DuracionMiniTest />
          </Grid>
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Caracterizacion />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default PruebaConocimientoPage;
